
export default {
  set (name, value) {
    var Days = 1
    var exp = new Date()
    exp.setTime(exp.getTime() + Days * 11 * 60 * 60 * 1000)
    document.cookie = name + '=' + escape(value) + ';expires=' + exp.toGMTString()
  },
  get (name) {
    // eslint-disable-next-line
    let arr, reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
    // eslint-disable-next-line
    if (arr = document.cookie.match(reg)) { return unescape(arr[2]) } else { return null }
  },
  del (name) {
    var exp = new Date()
    exp.setTime(exp.getTime() - 1)
    var cval = this.get(name)
    if (cval != null) { document.cookie = name + '=' + cval + ';expires=' + exp.toGMTString() }
  }
}



// WEBPACK FOOTER //
// ./src/http/cookie.js